import React from 'react';
import { X, MessageCircle } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import './QRCodeModal.css';

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  // Detect device type
  const getDeviceType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return 'ios';
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      return 'android';
    }

    // Desktop/other
    return 'other';
  };

  // Get messaging URL for button (device-specific)
  const getButtonUrl = () => {
    const hostname = window.location.hostname;
    const isDev = hostname.includes('dev.mantisflow.com') || hostname === 'localhost';
    const deviceType = getDeviceType();

    // Development environment - ALL devices use sandbox
    if (isDev) {
      return 'imessage://sandbox.loopmessage.com@imsg.im';
    }

    // Production environment - Device-specific
    else {
      if (deviceType === 'ios') {
        // iPhone on prod → Use production iMessage
        return 'imessage://remi@a.imsg.co';
      } else {
        // Android/Other on prod → Use SMS with phone number
        return 'sms:+16288679755?body=hi';
      }
    }
  };

  // Get messaging URL for QR code (always universal SMS for cross-device compatibility)
  const getQRCodeUrl = () => {
    // Always use SMS for QR codes - works on ALL devices (iPhone, Android, etc.)
    return 'sms:+16288679755?body=hi';
  };

  const buttonUrl = getButtonUrl();
  const qrCodeUrl = getQRCodeUrl();
  const deviceType = getDeviceType();

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="qr-modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="qr-modal-header">
          <h2 className="qr-modal-title">Message Remi</h2>
          <p className="qr-modal-subtitle">
            Scan this QR code to start chatting with Remi
          </p>
        </div>

        <div className="qr-code-container">
          <QRCodeSVG
            value={qrCodeUrl}
            size={256}
            level="H"
            includeMargin={true}
            className="qr-code-image"
          />
        </div>

        <div className="qr-modal-divider">
          <span>or</span>
        </div>

        <div className="qr-modal-footer">
          <button
            className="qr-modal-button"
            onClick={() => window.open(buttonUrl, '_blank')}
          >
            <MessageCircle size={16} />
            Text Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal;
